export enum AccountType {
  BLOCKED = 'blocked',
  CANCELLED = 'cancelled',
  DUPLICATED = 'duplicated',
  FREEACCOUNT = 'freeAccount',
  FREE_ACCOUNT = 'free account',
  INTERNAL = 'internal',
  INVALID = 'invalid',
  MASTER_ESTABLISHMENT = 'master establishment',
  RESELLER = 'reseller',
  SUBSCRIBED = 'subscribed',
  SUBSCRIPTION = 'subscription',
  SUSPENDED = 'suspended'
}
